export const BRANDS = [
  { name: "Acura", models: [
    { name: "RDX", category: "suv" }, { name: "MDX", category: "suv" },
    { name: "TLX", category: "berline" }, { name: "ILX", category: "compact" },
    { name: "Integra", category: "compact" },
  ]},
  { name: "Audi", models: [
    { name: "A3", category: "compact" }, { name: "A4", category: "berline" },
    { name: "A5", category: "berline" }, { name: "A6", category: "berline" },
    { name: "A7", category: "berline" }, { name: "A8", category: "berline" },
    { name: "Q2", category: "suv" }, { name: "Q3", category: "suv" },
    { name: "Q4 e-tron", category: "suv" }, { name: "Q5", category: "suv" },
    { name: "Q7", category: "suv" }, { name: "Q8", category: "suv" },
    { name: "TT", category: "compact" }, { name: "e-tron GT", category: "berline" },
  ]},
  { name: "BMW", models: [
    { name: "Série 1", category: "compact" }, { name: "Série 2", category: "compact" },
    { name: "Série 3", category: "berline" }, { name: "Série 4", category: "berline" },
    { name: "Série 5", category: "berline" }, { name: "Série 7", category: "berline" },
    { name: "X1", category: "suv" }, { name: "X2", category: "suv" },
    { name: "X3", category: "suv" }, { name: "X4", category: "suv" },
    { name: "X5", category: "suv" }, { name: "X6", category: "suv" },
    { name: "X7", category: "suv" }, { name: "i3", category: "compact" },
    { name: "i4", category: "berline" }, { name: "iX", category: "suv" },
    { name: "Z4", category: "compact" },
  ]},
  { name: "Buick", models: [
    { name: "Encore", category: "suv" }, { name: "Encore GX", category: "suv" },
    { name: "Envision", category: "suv" }, { name: "Enclave", category: "suv" },
  ]},
  { name: "Cadillac", models: [
    { name: "XT4", category: "suv" }, { name: "XT5", category: "suv" },
    { name: "XT6", category: "suv" }, { name: "Escalade", category: "suv" },
    { name: "Lyriq", category: "suv" }, { name: "CT4", category: "berline" },
    { name: "CT5", category: "berline" },
  ]},
  { name: "Chevrolet", models: [
    { name: "Silverado", category: "camion" }, { name: "Colorado", category: "camion" },
    { name: "Equinox", category: "suv" }, { name: "Traverse", category: "suv" },
    { name: "Tahoe", category: "suv" }, { name: "Suburban", category: "suv" },
    { name: "Blazer", category: "suv" }, { name: "Trax", category: "suv" },
    { name: "Trailblazer", category: "suv" }, { name: "Malibu", category: "berline" },
    { name: "Bolt EV", category: "compact" }, { name: "Spark", category: "compact" },
    { name: "Cruze", category: "compact" }, { name: "Camaro", category: "compact" },
    { name: "Corvette", category: "compact" },
  ]},
  { name: "Chrysler", models: [
    { name: "Pacifica", category: "suv" }, { name: "300", category: "berline" },
  ]},
  { name: "Dodge", models: [
    { name: "Durango", category: "suv" }, { name: "Journey", category: "suv" },
    { name: "Grand Caravan", category: "suv" }, { name: "Charger", category: "berline" },
    { name: "Challenger", category: "compact" },
  ]},
  { name: "Fiat", models: [
    { name: "500", category: "compact" }, { name: "500e", category: "compact" },
    { name: "500X", category: "suv" },
  ]},
  { name: "Ford", models: [
    { name: "F-150", category: "camion" }, { name: "F-250", category: "camion" },
    { name: "Ranger", category: "camion" }, { name: "Maverick", category: "camion" },
    { name: "Explorer", category: "suv" }, { name: "Escape", category: "suv" },
    { name: "Edge", category: "suv" }, { name: "Expedition", category: "suv" },
    { name: "Bronco", category: "suv" }, { name: "Bronco Sport", category: "suv" },
    { name: "EcoSport", category: "suv" }, { name: "Mustang Mach-E", category: "suv" },
    { name: "Fusion", category: "berline" }, { name: "Mustang", category: "compact" },
    { name: "Focus", category: "compact" },
  ]},
  { name: "Genesis", models: [
    { name: "GV70", category: "suv" }, { name: "GV80", category: "suv" },
    { name: "G70", category: "berline" }, { name: "G80", category: "berline" },
    { name: "G90", category: "berline" },
  ]},
  { name: "GMC", models: [
    { name: "Sierra", category: "camion" }, { name: "Canyon", category: "camion" },
    { name: "Hummer EV", category: "camion" }, { name: "Terrain", category: "suv" },
    { name: "Acadia", category: "suv" }, { name: "Yukon", category: "suv" },
  ]},
  { name: "Honda", models: [
    { name: "CR-V", category: "suv" }, { name: "HR-V", category: "suv" },
    { name: "Pilot", category: "suv" }, { name: "Passport", category: "suv" },
    { name: "Odyssey", category: "suv" }, { name: "Ridgeline", category: "camion" },
    { name: "Accord", category: "berline" }, { name: "Insight", category: "berline" },
    { name: "Civic", category: "compact" }, { name: "Fit", category: "compact" },
  ]},
  { name: "Hyundai", models: [
    { name: "Tucson", category: "suv" }, { name: "Santa Fe", category: "suv" },
    { name: "Palisade", category: "suv" }, { name: "Kona", category: "suv" },
    { name: "Venue", category: "suv" }, { name: "Ioniq 5", category: "suv" },
    { name: "Santa Cruz", category: "camion" }, { name: "Sonata", category: "berline" },
    { name: "Ioniq 6", category: "berline" }, { name: "Elantra", category: "compact" },
    { name: "Accent", category: "compact" }, { name: "Veloster", category: "compact" },
  ]},
  { name: "Infiniti", models: [
    { name: "QX50", category: "suv" }, { name: "QX60", category: "suv" },
    { name: "QX80", category: "suv" }, { name: "Q50", category: "berline" },
    { name: "Q60", category: "compact" },
  ]},
  { name: "Jeep", models: [
    { name: "Gladiator", category: "camion" }, { name: "Wrangler", category: "suv" },
    { name: "Grand Cherokee", category: "suv" }, { name: "Cherokee", category: "suv" },
    { name: "Compass", category: "suv" }, { name: "Renegade", category: "suv" },
    { name: "Wagoneer", category: "suv" },
  ]},
  { name: "Kia", models: [
    { name: "Sportage", category: "suv" }, { name: "Sorento", category: "suv" },
    { name: "Telluride", category: "suv" }, { name: "Seltos", category: "suv" },
    { name: "Niro", category: "suv" }, { name: "EV6", category: "suv" },
    { name: "Carnival", category: "suv" }, { name: "Sedona", category: "suv" },
    { name: "K5", category: "berline" }, { name: "Stinger", category: "berline" },
    { name: "Forte", category: "compact" }, { name: "Rio", category: "compact" },
    { name: "Soul", category: "compact" },
  ]},
  { name: "Lexus", models: [
    { name: "RX", category: "suv" }, { name: "NX", category: "suv" },
    { name: "UX", category: "suv" }, { name: "GX", category: "suv" },
    { name: "LX", category: "suv" }, { name: "ES", category: "berline" },
    { name: "IS", category: "berline" }, { name: "LS", category: "berline" },
    { name: "RC", category: "compact" },
  ]},
  { name: "Lincoln", models: [
    { name: "Corsair", category: "suv" }, { name: "Nautilus", category: "suv" },
    { name: "Aviator", category: "suv" }, { name: "Navigator", category: "suv" },
  ]},
  { name: "Mazda", models: [
    { name: "CX-3", category: "suv" }, { name: "CX-30", category: "suv" },
    { name: "CX-5", category: "suv" }, { name: "CX-50", category: "suv" },
    { name: "CX-9", category: "suv" }, { name: "CX-90", category: "suv" },
    { name: "Mazda6", category: "berline" }, { name: "Mazda3", category: "compact" },
    { name: "MX-5", category: "compact" },
  ]},
  { name: "Mercedes-Benz", models: [
    { name: "GLA", category: "suv" }, { name: "GLB", category: "suv" },
    { name: "GLC", category: "suv" }, { name: "GLE", category: "suv" },
    { name: "GLS", category: "suv" }, { name: "Classe G", category: "suv" },
    { name: "Classe C", category: "berline" }, { name: "Classe E", category: "berline" },
    { name: "Classe S", category: "berline" }, { name: "EQE", category: "berline" },
    { name: "EQS", category: "berline" }, { name: "Classe A", category: "compact" },
    { name: "CLA", category: "compact" },
  ]},
  { name: "Mini", models: [
    { name: "Countryman", category: "suv" }, { name: "Cooper", category: "compact" },
    { name: "Cooper S", category: "compact" }, { name: "Clubman", category: "compact" },
  ]},
  { name: "Mitsubishi", models: [
    { name: "RVR", category: "suv" }, { name: "Outlander", category: "suv" },
    { name: "Eclipse Cross", category: "suv" }, { name: "Mirage", category: "compact" },
    { name: "Lancer", category: "compact" },
  ]},
  { name: "Nissan", models: [
    { name: "Titan", category: "camion" }, { name: "Frontier", category: "camion" },
    { name: "Rogue", category: "suv" }, { name: "Murano", category: "suv" },
    { name: "Pathfinder", category: "suv" }, { name: "Kicks", category: "suv" },
    { name: "Qashqai", category: "suv" }, { name: "Ariya", category: "suv" },
    { name: "Juke", category: "suv" }, { name: "Armada", category: "suv" },
    { name: "Altima", category: "berline" }, { name: "Maxima", category: "berline" },
    { name: "Sentra", category: "compact" }, { name: "Versa", category: "compact" },
    { name: "Leaf", category: "compact" },
  ]},
  { name: "Peugeot", models: [
    { name: "2008", category: "suv" }, { name: "3008", category: "suv" },
    { name: "5008", category: "suv" }, { name: "508", category: "berline" },
    { name: "208", category: "compact" }, { name: "308", category: "compact" },
  ]},
  { name: "Porsche", models: [
    { name: "Macan", category: "suv" }, { name: "Cayenne", category: "suv" },
    { name: "Taycan", category: "berline" }, { name: "Panamera", category: "berline" },
    { name: "911", category: "compact" },
  ]},
  { name: "RAM", models: [
    { name: "1500", category: "camion" }, { name: "2500", category: "camion" },
    { name: "3500", category: "camion" }, { name: "ProMaster", category: "camion" },
  ]},
  { name: "Subaru", models: [
    { name: "Crosstrek", category: "suv" }, { name: "Forester", category: "suv" },
    { name: "Outback", category: "suv" }, { name: "Ascent", category: "suv" },
    { name: "Solterra", category: "suv" }, { name: "Legacy", category: "berline" },
    { name: "Impreza", category: "compact" }, { name: "WRX", category: "compact" },
    { name: "BRZ", category: "compact" },
  ]},
  { name: "Tesla", models: [
    { name: "Model Y", category: "suv" }, { name: "Model X", category: "suv" },
    { name: "Model 3", category: "berline" }, { name: "Model S", category: "berline" },
    { name: "Cybertruck", category: "camion" },
  ]},
  { name: "Toyota", models: [
    { name: "RAV4", category: "suv" }, { name: "Highlander", category: "suv" },
    { name: "4Runner", category: "suv" }, { name: "Corolla Cross", category: "suv" },
    { name: "Venza", category: "suv" }, { name: "Sequoia", category: "suv" },
    { name: "Land Cruiser", category: "suv" }, { name: "C-HR", category: "suv" },
    { name: "bZ4X", category: "suv" }, { name: "Sienna", category: "suv" },
    { name: "Tundra", category: "camion" }, { name: "Tacoma", category: "camion" },
    { name: "Camry", category: "berline" }, { name: "Avalon", category: "berline" },
    { name: "Corolla", category: "compact" }, { name: "Prius", category: "compact" },
    { name: "GR86", category: "compact" }, { name: "Supra", category: "compact" },
  ]},
  { name: "Volkswagen", models: [
    { name: "Tiguan", category: "suv" }, { name: "Atlas", category: "suv" },
    { name: "Atlas Cross Sport", category: "suv" }, { name: "Taos", category: "suv" },
    { name: "ID.4", category: "suv" }, { name: "Passat", category: "berline" },
    { name: "Arteon", category: "berline" }, { name: "Golf", category: "compact" },
    { name: "GTI", category: "compact" }, { name: "Jetta", category: "compact" },
    { name: "Beetle", category: "compact" },
  ]},
  { name: "Volvo", models: [
    { name: "XC40", category: "suv" }, { name: "XC60", category: "suv" },
    { name: "XC90", category: "suv" }, { name: "EX30", category: "suv" },
    { name: "EX90", category: "suv" }, { name: "C40", category: "suv" },
    { name: "S60", category: "berline" }, { name: "S90", category: "berline" },
    { name: "V60", category: "berline" }, { name: "V90", category: "berline" },
  ]},
];

export const CATEGORY_LABELS = {
  suv: "SUV & 4×4",
  berline: "Berline",
  camion: "Camion & Pickup",
  compact: "Compacte",
};

export const RECOMMENDED = {
  suv: { id: "nordiguard-sur-mesure", name: "Sur-Mesure 3D" },
  berline: { id: "nordiguard-sur-mesure", name: "Sur-Mesure 3D" },
  camion: { id: "nordiguard-sur-mesure", name: "Sur-Mesure 3D" },
  compact: { id: "nordiguard-sur-mesure", name: "Sur-Mesure 3D" },
};

export const findVehicle = (marque, modele) => {
  const brand = BRANDS.find((b) => b.name === marque);
  const model = brand?.models.find((m) => m.name === modele);
  return model ? { marque, modele, category: model.category } : null;
};

const norm = (s) => s.toLowerCase().replace(/[^a-z0-9]/g, "");

export const matchesVehicle = (product, marque, modele) => {
  if (!marque || !modele || !product) return false;
  if (product.id === "nordiguard-sur-mesure") return true;
  if (!product.compatibility) return false;
  const m = norm(modele);
  const b = norm(marque.split(/[\s-]/)[0]);
  return product.compatibility.some((c) => {
    const cn = norm(c);
    return cn.includes(m) && cn.includes(b);
  });
};
